import React from 'react';
import { useNavigate } from 'react-router-dom';

const PastMemories = () => {
  const navigate = useNavigate();
  const memories = JSON.parse(localStorage.getItem('memories') || '[]');

  const viewMemory = (id) => {
    navigate(`/memory/${id}`);
  };

  return (
    <div className="past-memories-container">
      <h2>Your Memory Collection</h2>
      <div className="memories-grid">
        {memories.map((memory) => (
          <div key={memory.id} className="memory-card" onClick={() => viewMemory(memory.id)}>
            <h3>{memory.title}</h3>
            <p className="memory-date">{memory.date}</p>
            <p className="memory-location">{memory.location}</p>
            <p className="memory-preview">{memory.details.substring(0, 100)}...</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PastMemories; 